module.exports = __webpack_public_path__ + "static/media/nss_logo.ae7b404c.png";